import '../../App.css'
import { Table } from 'react-bootstrap';
import { faCircleUser, faEdit, faEye, faEyeSlash, faFile, faTrash, faUserLargeSlash, faUserPlus} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import  { useState } from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';

import axios from 'axios';
import URLPage from '../../endPoints/endpoints';
import * as usersListActions from "../../redux/listUsers/listUsersActions"
import * as hideNavbarActions from "../../redux/hideNavBar/hideNavbarActions"



function ListUsersBody() {
   const dispatch = useDispatch();
   const [userDetail, setUserDetail] =  useState({detail: null});
   const [modalDeleteUser, setModalDeleteUser] = useState(false)
   const [closeUserDetail, setCloseUserDetail] = useState(false)
   
   const [modalAddUser, setModalAddUser] = useState(false);
   const [userName, setUserName] = useState('');
   const [password, setPassword] = useState('');
   const [mail, setMail] = useState('');
   const [phone, setPhone] = useState('');
   const [messagebyAddUser, setMessageByAddUser] = useState('');

   const [modalEditUser, setModalEditUser] = useState(false)
   const [userNameEdit, setUserNameEdit] = useState('');
   const [mailEdit, setMailEdit] = useState('');
   const [phoneEdit, setPhoneEdit] = useState('');
   const [messageByEditUser, setMessageByEditUser] = useState('')

   const listUsers = useSelector(state => state.usersList.users.users);
   const token = useSelector(state => state.us.current.token);

  const [eye,  setEye] = useState(false);



  const handleEye = () => {
    if (eye) {
      setEye(false)
      return
    } else {
      setEye(true)
    }
  }
  
   function getUsersListNew (token1) {

        
    axios.get(`${URLPage}/api/users/list-users`, {
    headers: 
    {
      'x-token': token1
    }

  }) // second
  .then(response => {
    
    dispatch(usersListActions.setUsersList(response.data));
    
    
  })
  .catch(error => {
    alert(error)
   return
  });
}


   const handleUserAndClose = (payload) => {

     if (closeUserDetail) {
       setUserDetail({ detail: {userName:'', mail:'', phone:'', uid: ''}})
       setCloseUserDetail(false);
       dispatch(hideNavbarActions.setHideNavbar());
       setModalDeleteUser(false)
       return
      }
      setUserDetail({ detail: payload} )
      setCloseUserDetail(true);
      dispatch(hideNavbarActions.setHideNavbar());

   } 

   const handleOpenDeleteModal = () => {

    if (!modalDeleteUser) {
    setCloseUserDetail(false)
    setModalDeleteUser(true)
    return
  }
  
  dispatch(hideNavbarActions.setHideNavbar());
    
    setModalDeleteUser(false)
    

   }
   
   const handleOpenAddUser = () => {
     
      if (!modalAddUser) {
        setModalAddUser(true);
        dispatch(hideNavbarActions.setHideNavbar());
        return
      }

      setModalAddUser(false)
      dispatch(hideNavbarActions.setHideNavbar());

   }

  const handleOpenEditUser = () => {
      
    if (!modalEditUser) {
    setCloseUserDetail(false)
    setModalEditUser(true)
    setUserNameEdit(userDetail.detail?.userName || '');
    setMailEdit(userDetail.detail?.mail || '');
    setPhoneEdit(userDetail.detail?.phone || '');
   
    return
  }
  
         
    dispatch(hideNavbarActions.setHideNavbar());     
    setModalEditUser(false)
    

   }

   const handleYesDeleteUser = (e) => {
     e.preventDefault();
    axios.delete(`${URLPage}/api/users/${userDetail.detail?.uid}`, {
    headers: 
    {
      'x-token': token
    }

  }) // first 
  .then(response => {
     getUsersListNew(token)
     setModalDeleteUser(false)
     dispatch(hideNavbarActions.setHideNavbar());
    
    
  })
  .catch(error => {
    alert(error)
    setModalDeleteUser(false)
   return
  });
   }

   const data = {
    
    userName: userName,
    password: password,
    rol: "USER_ROLE",
    mail: mail,
    phone: phone

}

   const handleAddUserYes = (e) => {
      e.preventDefault();

    axios.post(`${URLPage}/api/users`, data, {
    headers: {
      'x-token': token,
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    getUsersListNew(token)
    dispatch(hideNavbarActions.setHideNavbar());
    setModalAddUser(false)
    setUserName('');
    setMail('')
    setPassword('')
    setPhone('');
    
  })
  .catch(error => {
   setMessageByAddUser(error.response.data.errors[0].msg);
  });
};

const dataEditUser = 
{
   userName: userNameEdit,
   mail: mailEdit,
   phone: phoneEdit
}


const handleYesEditUser = (e) => {
    e.preventDefault();
    axios.put(`${URLPage}/api/users/user/${userDetail.detail?.uid}`, dataEditUser, {
    headers: {
      'x-token': token,
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    
    if (response.data.msg ==  'Password changed') {
       setModalEditUser(false)
       dispatch(hideNavbarActions.setHideNavbar());
       getUsersListNew(token)
      return
    } else {
      setMessageByEditUser(response.data.msg)
      return
    }
    
  })
  .catch(error => {;
    console.log(error?.response.data.errors[0].msg)
  });
    
  }
   


   return <>
    {/* Modal User Details */}
  <Modal
        isOpen={closeUserDetail}     
        overlayClassName="glass-overlay"
        className="glass-content card"
        data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="2000"
      >
     <div className="card text-center">
        <div className="card-footer text-body-secondary text-end">
        <button className="btn btn-secondary me-2" onClick={handleOpenEditUser}><FontAwesomeIcon icon={faEdit} /></button> <button className="btn btn-dark" onClick={ handleOpenDeleteModal}><FontAwesomeIcon icon={faTrash}/></button>
     </div>
     <div className="card-header">
       Id: {userDetail.detail?.uid}
      </div>
     <div className="card-body">
     <h5 className="card-title">User: { userDetail.detail?.userName}</h5>
     <p className="card-text">Email: {userDetail.detail?.mail}</p>
     <p className="card-text">Phone: {userDetail.detail?.phone}</p>
   

    <button className="btn btn-primary" onClick={handleUserAndClose}>Close</button>
    </div>
  
    </div> 
  </Modal>

  {/* Modal user delete by Admin*/}
  <Modal
           isOpen={modalDeleteUser}     
           overlayClassName="glass-overlay"
           className="glass-content card"
           data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="2000"
         >
         <div></div>
         <h5 className="card-header">Delete user <FontAwesomeIcon icon={faUserLargeSlash}/></h5>
         <p>Id: {userDetail.detail?.uid} </p>
         <div className="card-body">
          <h5 className="card-title">Do you want to delete user: {userDetail.detail?.userName}</h5>
      
        <div className="d-flex justify-content-between mx-auto" style={{ width: '90%' }}>
        <button className='btn btn-danger'  style={{ width: '45%' }} onClick={handleYesDeleteUser }>YES</button>
         <button className='btn btn-primary'  style={{ width: '45%' }} onClick={handleOpenDeleteModal}>NO</button>
        </div>
         </div>
   </Modal>

   {/* Modal Add User */}
    
     <Modal
        isOpen={modalAddUser}     
        overlayClassName="glass-overlay"
        className="glass-content card "
        data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="2000"
      >
     <div className="card text-center">
        <div className="card-footer text-body-secondary ">
        <h2 className='text-center mt-2'><FontAwesomeIcon style={{color:'#294983'}}  icon={faCircleUser} size='2x' /></h2>
        <h3>Add user</h3>
     </div>
     <div className="card-header">
      <p className='text-danger'>{messagebyAddUser}</p>
    </div>
     <div className="card-body">
    <form onSubmit={handleAddUserYes}>


    <div className="form-group  mb-2">
     <label className="w-100 text-start">User name:</label>
     <input type="text" className="form-control"  placeholder="Enter username" required
            onChange={(e) => setUserName(e.target.value)}
            value={userName}
            onClick={() => setMessageByAddUser('')}
     />
    
    </div>  
     
    <div className="form-group  mb-2">
     <label className="w-100 text-start">Email address:</label>
     <input type='email' className="form-control"  placeholder="Enter email" required
            onChange={(e) => setMail(e.target.value)}
            value={mail} 
            onClick={() => setMessageByAddUser('')}
     />
    
    </div>

    <div className="form-group  mb-2">
     <label className="w-100 text-start">Phone:</label>
     <input type="number" className="form-control"  placeholder="Enter phone" required
            onChange={(e) => setPhone(e.target.value)}
            value={phone}
            onClick={() => setMessageByAddUser('')}
     />
    </div>

    <div className="form-group mb-4">
     <label className="w-100 text-start">Password:</label>
     <div className='input-group'>

     <input  className="form-control" placeholder="Enter password" minLength={8} required
             onChange={(e) => setPassword(e.target.value)}
             value={password}
             onClick={() => setMessageByAddUser('')}
             type={!eye ? 'password' : 'text'}
             />
     
                    <button onClick={handleEye} className="btn  button-password" type="button">
                       <FontAwesomeIcon icon={eye ? faEye : faEyeSlash} />
                     </button>

     </div>
    
    </div>


    

    

    <div className='d-flex justify-content-evenly'>
    <button className='btn btn-warning'>Add User <FontAwesomeIcon icon={faUserPlus} /></button>
    <button type='button' className="btn btn-primary" onClick={handleOpenAddUser} >Cancel</button>
    </div> 
    
    
    </form>
    </div>
  
    </div> 
  </Modal>

  {/* Edit User By Admin */}

     <Modal
        isOpen={modalEditUser}     
        overlayClassName="glass-overlay"
        className="glass-content card "
        data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="2000"
      >
     <div className="card text-center">
        <div className="card-footer text-body-secondary ">
        <h2 className='text-center mt-2'><FontAwesomeIcon style={{color:'#294983'}}  icon={faCircleUser} size='2x' /></h2>
        <h3>Edit user <FontAwesomeIcon icon={faEdit}/></h3>
     </div>
     <div className="card-header">
      <p className='text-danger'>{messageByEditUser}</p>
    </div>
     <div className="card-body">
    <form >


    <div className="form-group  mb-2">
     <label className="w-100 text-start">User name:</label>
     <input type="text" className="form-control"  placeholder="Enter username" required
            onChange={(e) => setUserNameEdit(e.target.value)}
            value={userNameEdit}
            onClick={() => setMessageByEditUser('')}
            
     />
    
    </div>  
     
    <div className="form-group  mb-2">
     <label className="w-100 text-start">Email address:</label>
     <input type='email' className="form-control"  placeholder="Enter email" required
            onChange={(e) => setMailEdit(e.target.value)}
            value={mailEdit} 
            onClick={() => setMessageByEditUser('')}
           
     />
    
    </div>

    <div className="form-group  mb-2">
     <label className="w-100 text-start">Phone:</label>
     <input type="number" className="form-control"  placeholder="Enter phone" required
            onChange={(e) => setPhoneEdit(e.target.value)}
            value={phoneEdit}
            onClick={() => setMessageByEditUser('')}
            
     />
    </div>




    

    

    <div className='d-flex justify-content-evenly'>
    <button className='btn btn-dark' onClick={handleYesEditUser}>Edit user <FontAwesomeIcon icon={faEdit} /></button>
    <button type='button' className="btn btn-primary" onClick={handleOpenEditUser}>Cancel</button>
    </div> 
    
    
    </form>
    </div>
  
    </div> 
  </Modal>


   




    <div className='users-title'>
     <h4>Users</h4>
     <Button variant="warning" onClick={handleOpenAddUser}>Add User <FontAwesomeIcon  icon={faUserPlus}/> </Button>
            
    </div>
    <Table striped bordered hover >
      <thead>
        <tr>
          <th></th>
          <th>Username</th>
          <th>Phone</th>
        </tr>
      </thead>
      <tbody>
           {listUsers?.map((user, index) => (
           
          <tr key={index}>
            <td><Button variant="success"  onClick={()=> { handleUserAndClose(user)}}> 
            <FontAwesomeIcon
            icon={faFile}
            size="2x"
            style={{ cursor: 'pointer', color: 'white' }}
            
            /> </Button></td>
            <td>{user.userName}</td>
            <td>{user.phone}</td>
        
      
          </tr>
          ))}
    
       
      </tbody>
    </Table>
    </>
}

export default ListUsersBody